import React from 'react';
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ComparisonTable from "../../../components/ComparisonTable/ComparisonTable";
import SEO from "../../../utils/SEO";

export default function AnjouanJurisdiction() {

    return (
        <main className='main'>
            <SEO
                title="Anjouan Offshore | AOFA Licensing & Company Formation "
                description="Set up offshore companies in Anjouan (Comoros). AOFA-regulated hub for forex, crypto, gaming, and fintech licensing with fast approvals. "
                keywords="Anjouan offshore, AOFA licensing, offshore company formation Comoros, forex license Anjouan, crypto license Anjouan, gaming license offshore, fintech license Comoros, offshore jurisdiction Africa "
                url="/anjouan-jurisdiction"
            />
            <IntroSection
                title="Anjouan (Comoros) Jurisdiction"
                subtitle="A Flexible Offshore Licensing Center in the Comoros"
                description="Anjouan, one of the islands of the Union of Comoros, has developed into a modern offshore financial hub, offering cost-effective licensing solutions under the Anjouan Offshore Finance Authority (AOFA). Known for its fast approvals and affordable fees, Anjouan is a top choice for startups and entrepreneurs in forex, crypto, gaming, and fintech sectors."
                badges={[
                    "Forex & Brokerage",
                    "Gaming & iGaming",
                    "Crypto & Blockchain",
                    "Banking & Finance"
                ]}
                buttonText="Request an Anjouan Proposal →"
                buttonLink="/quote"
                imageSrc={require('../../../assets/images/jurisdictions/anjouan-ju.png')}
                imageAlt="Anjouan Comoros Offshore Jurisdiction"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title="Why Choose Anjouan?"
                        blocks={[
                            {
                                items: [
                                    { text: "Fast Licensing — approvals in as little as 4–8 weeks." },
                                    { text: "Cost-Effective — lower setup and renewal costs than Mauritius or Seychelles." },
                                    { text: "International Use — licenses designed for global activity outside Comoros." },
                                    { text: "FATF-Aligned — compliance framework based on international AML/KYC standards." },
                                    { text: "Startup-Friendly — excellent for new entrants in forex, gaming, or crypto." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Licensing Opportunities in Anjouan"
                        blocks={[
                            {
                                items: [
                                    { title: "Banking & Payment Licenses", text: "Operate as an offshore bank or EMI, providing payment services globally." },
                                    { title: "Forex & Brokerage Licenses", text: "Run STP/ECN brokerages, CFDs, or prop trading firms with low entry costs." },
                                    { title: "Gaming & iGaming Licenses", text: "Launch online casinos, sportsbooks, lotteries, or eSports platforms." },
                                    { title: "Crypto & Blockchain Licenses", text: "Register as a Virtual Asset Service Provider (VASP) for exchanges, wallets, or token issuance." },
                                    { title: "Insurance & Trust Licenses", text: "Set up captives, reinsurance firms, or fiduciary structures." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Benefits of Anjouan Jurisdiction"
                        blocks={[
                            {
                                items: [
                                    { text: "Speed — licenses issued faster than most offshore jurisdictions." },
                                    { text: "Flexibility — modular licensing covering multiple sectors." },
                                    { text: "Crypto-Friendly — ideal for blockchain, tokenization, and DeFi projects." },
                                    { text: "Affordable — one of the lowest-cost offshore licensing options." },
                                    { text: "Global Use — designed for international clients, not domestic operations." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Incorporation & Licensing Process"
                        blocks={[
                            {
                                items: [
                                    { text: "company-formation — register an International Business Company (IBC) in Anjouan." },
                                    { text: "Documentation — AML/KYC manuals, risk framework, business plan." },
                                    { text: "Application Filing — Offshore Advisory submits to AOFA." },
                                    { text: "Regulatory Review — AOFA evaluates compliance and documentation." },
                                    { text: "Approval & Issuance — license granted, operations can begin." }
                                ]
                            }
                        ]}
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "4–8 weeks (among the fastest)",
                            },
                            {
                                name: "Setup Costs",
                                description: "Starting from USD 12,000–20,000+ depending on license",
                            },
                            {
                                name: "Capital Requirement",
                                description: "❌ None for most licenses (major advantage)",
                            },
                            {
                                name: "Annual Costs",
                                description: "Annual fees lower than Seychelles, Belize, or Mauritius",
                            },
                        ]}
                    />

                    <ComparisonTable
                        title="Anjouan vs Mwali vs Other Jurisdictions"
                        columns={columns}
                        data={data}
                    />

                    <DetailsSection title='Why Offshore Advisory for Anjouan?'
                                    items={
                                        [
                                            { text: "Recognized AOFA agent with experience in all license types" },
                                            { text: "End-to-end service: incorporation, compliance, licensing, and banking" },
                                            { text: "Access to white-label platforms for brokers and gaming" },
                                            { text: "Crypto PSP and EMI introductions." },
                                            { text: "Transparent pricing & reliable support." },
                                        ]
                                    }
                                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking for a fast, affordable offshore license?"
                        description="Anjouan offers crypto, forex, gaming, banking, and insurance licenses with no capital requirements and rapid approvals."
                        buttonText="Book an Anjouan Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const columns = [
    "feature",
    "Anjouan (Comoros)",
    "Mwali (Comoros)",
    "Western Sahara (CRA)",
    "Mauritius"
];

const data = [
    {
        feature: "Capital Requirement",
        "Anjouan (Comoros)": "❌ None",
        "Mwali (Comoros)": "USD 50k–150k+",
        "Western Sahara (CRA)": "❌ None",
        "Mauritius": "USD 250k–1M+",
    },
    {
        feature: "Recognition",
        "Anjouan (Comoros)": "Growing",
        "Mwali (Comoros)": "Established",
        "Western Sahara (CRA)": "Emerging",
        "Mauritius": "Strong (Tier-2)",
    },
    {
        feature: "Setup Time",
        "Anjouan (Comoros)": "4–8 weeks",
        "Mwali (Comoros)": "2–3 weeks",
        "Western Sahara (CRA)": "1–2 weeks",
        "Mauritius": "3–6 months",
    },
    {
        feature: "Cost",
        "Anjouan (Comoros)": "Low",
        "Mwali (Comoros)": "Moderate",
        "Western Sahara (CRA)": "Low",
        "Mauritius": "High",
    },
    {
        feature: "Best For",
        "Anjouan (Comoros)": "Startups, crypto, gaming",
        "Mwali (Comoros)": "Brokers, banks, funds",
        "Western Sahara (CRA)": "Multi-sector startups",
        "Mauritius": "Institutional investors",
    },
];

const faqData = [
    {
        question: "Is Anjouan recognized internationally?",
        answer: "Yes — while newer than Mwali, Anjouan is increasingly accepted in offshore financial and crypto sectors.",
    },
    {
        question: "Is there a capital requirement?",
        answer: "No — most licenses require no minimum paid-up capital.",
    },
    {
        question: "How long does licensing take?",
        answer: "4–8 weeks, faster than many offshore regulators.",
    },
    {
        question: "Can I combine licenses?",
        answer: "Yes — AOFA allows modular licensing for multi-sector businesses, such as forex and crypto together.",
    },
    {
        question: "Is Anjouan good for startups?",
        answer: "Yes — it’s one of the most affordable and flexible offshore jurisdictions.",
    },
];

const testimonialsData = [
    {
        quote: "Offshore Advisory helped us license our forex brokerage in Anjouan in 5 weeks. Fast, simple, and affordable.",
        author: "David L.",
        role: "Broker Founder"
    },
    {
        quote: "We launched a crypto exchange under Anjouan licensing. Offshore Advisory handled compliance and PSP integration perfectly.",
        author: "Sophia M.",
        role: "Blockchain Entrepreneur"
    }
];
